import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { DecimalPipe } from '@angular/common';
import { LoaderService } from './app/services/loader.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoaderInterceptorService } from './app/services/loader-interceptor.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

fetch('assets/config/configurationOK.json')
  .then((res) => res.json())
  .then((configuration) => {
    if (environment.production) {
      enableProdMode();
    }
    environment.mobileTrackerUrl= configuration.mobileTrackerUrl;
    environment.budgetcalcUrl= configuration.budgetcalcUrl;
    environment.taxRate= configuration.taxRate;
    environment.minPrepayment= configuration.minPrepayment;
    environment.maxLengthFreeText= configuration.maxLengthFreeText;
    environment.startpagepaths= configuration.startpagepaths;

    bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, NouisliderModule),
        DecimalPipe,
        LoaderService,
        {
            provide: LOCALE_ID,
            useValue: 'de-DE'
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptorService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
      .catch((err) => console.error(err));
  });
